/**
 * @generated SignedSource<<136f6eb3c6ce4cf310c9c698de8d283b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useAuthProvider_mediaSession$data = {
  readonly configuration: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  };
  readonly token: {
    readonly duration: number;
    readonly expiryDateTime: AGG$Long;
    readonly value: string;
  };
  readonly " $fragmentType": "useAuthProvider_mediaSession";
};
export type useAuthProvider_mediaSession$key = {
  readonly " $data"?: useAuthProvider_mediaSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuthProvider_mediaSession">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useAuthProvider_mediaSession",
  "selections": [
    {
      "concreteType": "MediaToken",
      "kind": "LinkedField",
      "name": "token",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "kind": "ScalarField",
          "name": "duration"
        },
        {
          "kind": "ScalarField",
          "name": "expiryDateTime"
        }
      ]
    },
    {
      "concreteType": "MediaConfiguration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "clientId"
        },
        {
          "kind": "ScalarField",
          "name": "fileStoreUrl"
        }
      ]
    }
  ],
  "type": "ContentMediaSession"
};

(node as any).hash = "b6236d605ad5cddede0d44adc63193ec";

export default node;
